import styled from 'styled-components';

export const SettingContainer = styled.div`
  margin: 0 auto;
  width: 300px;
  text-align: center;
  font-weight: bold;
`;
